import { comics } from "@/mocks/comics";

export default function Ongoing() {
  const sweet = comics.filter((c) => c.categories.includes("甜宠漫画"));
  const featured = sweet[0];
  const rest = sweet.slice(1, 6);

  return (
    <section id="ongoing" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-sm font-semibold text-primary-600">高甜不虐 · 双向奔赴</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">甜宠连载进行中</h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            恋爱剧情甜到冒泡，每周稳定更新，追更不迷路。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <article className="overflow-hidden rounded-lg bg-background-50 lg:col-span-2">
            <div className="relative aspect-[3/4]">
              <img
                src={featured.cover}
                alt={`${featured.title}漫画封面`}
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
                  本周人气 No.1
                </span>
                <h3 className="mt-2 font-heading text-xl text-background-50 md:text-2xl">{featured.title}</h3>
                <p className="mt-1 text-xs text-background-200">{featured.author} · {featured.rating} 分</p>
              </div>
            </div>
          </article>

          <div className="lg:col-span-3">
            <div className="rounded-lg bg-background-50 p-5 md:p-6">
              <div className="flex flex-wrap gap-2">
                {featured.categories.map((cat) => (
                  <span key={cat} className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                    {cat}
                  </span>
                ))}
              </div>
              <h3 className="mt-4 font-heading text-xl text-foreground-950 md:text-2xl">{featured.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.description}</p>
              <p className="mt-3 text-sm text-primary-600">
                <i className="ri-flashlight-fill mr-1" aria-hidden="true"></i>
                {featured.latestChapter}
              </p>
              <div className="mt-5 flex flex-wrap gap-3">
                <button type="button" className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600">
                  <i className="ri-play-fill mr-1" aria-hidden="true"></i>
                  开始阅读
                </button>
                <button type="button" className="whitespace-nowrap rounded-md bg-secondary-100 px-5 py-2.5 text-sm font-semibold text-secondary-900 hover:bg-secondary-200">
                  <i className="ri-bookmark-line mr-1" aria-hidden="true"></i>
                  收藏追更
                </button>
              </div>
            </div>

            <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {rest.map((c) => (
                <li key={c.id}>
                  <a
                    href="#ongoing"
                    className="group flex items-center gap-3 rounded-lg bg-background-50 p-3 transition-colors hover:bg-primary-100"
                  >
                    <img
                      src={c.cover}
                      alt={`${c.title}漫画封面`}
                      className="h-20 w-16 shrink-0 rounded-md object-cover object-top"
                    />
                    <span className="min-w-0">
                      <span className="block truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                        {c.title}
                      </span>
                      <span className="mt-1 block truncate text-xs text-foreground-600">{c.latestChapter}</span>
                      <span className="mt-1 block text-xs text-primary-600">{c.rating} 分 · {c.reads} 追更</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}